import {
  createFeatureSelector,
  createSelector,
  MemoizedSelector,
} from '@ngrx/store';
import { defaultCountry } from '../service-options/service-options.selectors';
import { StatesState } from './states.model';

const selectState = createFeatureSelector<StatesState>('statesState');

export const stateInfo = createSelector(selectState, (state: any) =>
  state ? state : undefined
);

export const isStatesResolved = createSelector(
  stateInfo,
  (state: any) => state && state.isResolved
);

export const getCountryStates: MemoizedSelector<any, any> = createSelector(
  [stateInfo, defaultCountry],
  (statesInfo, country) => statesInfo && statesInfo[country]
);
